import { useCart } from '@/context/MenuCartContext';
/** Ссылка «назад в меню»: выбранное меню из корзины/контекста или список меню. */
export function useMenuHomePath() {
    const { checkoutMenuId } = useCart();
    if (checkoutMenuId != null) {
        return `/menu/${checkoutMenuId}/category`;
    }
    return '/menu';
}
